// src/components/Layout.tsx
import { Outlet } from "react-router-dom";
import SidebarContent from "../sideMenu";
import "./style.scss";

const Layout = () => {
  return (
    <div className="main-content">
      <SidebarContent />
      <div className="content-wrapper">
        <div className="content-wrapper-bg">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
